import { useEffect, useRef } from "react";
import {
  eventListener,
  IActionBarUpdate,
  IPropertySelection,
  TOPICS,
} from "@origin-digital/event-dispatcher";

/**
 * If the action bar updates with showAllProperties=false, but all-properties is currently selected, then select the
 * first property from the list.
 */
export const useDeselectAllOnDisableAllProperties = (
  propertySelection: IPropertySelection | null,
  setPropertySelection: (property: IPropertySelection | null) => void,
  properties: IPropertySelection[] | undefined
) => {
  const propertySelectionRef = useRef<IPropertySelection | null>(
    propertySelection
  );
  propertySelectionRef.current = propertySelection;
  const propertiesRef = useRef<IPropertySelection[] | undefined>(properties);
  propertiesRef.current = properties;

  useEffect(() => {
    return eventListener.addListener(
      TOPICS.ACTION_BAR_UPDATE,
      (topic: IActionBarUpdate) => {
        if (
          topic.payload.propertySelector &&
          !topic.payload.propertySelector.showAllProperties &&
          propertySelectionRef.current === null &&
          propertiesRef.current?.length
        ) {
          const firstProperty = propertiesRef.current[0];
          setPropertySelection(firstProperty);
        }
      }
    );
  }, []);
};
